import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Curadoria de Cadastros", -1)
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1)
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1)
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-5",
  style: {"padding-top":"4px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-btn-group ss-tamanho-completo" })
], -1)
const _hoisted_14 = { class: "ss-tela-conteudo" }
const _hoisted_15 = { class: "ss-card ss-card-space" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_20 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_selecionar_contratante = _resolveComponent("selecionar-contratante")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_status_curadoria_cadastro = _resolveComponent("selecionar-status-curadoria-cadastro")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_pais_modal = _resolveComponent("pais-modal")!
  const _component_estado_modal = _resolveComponent("estado-modal")!
  const _component_cidade_modal = _resolveComponent("cidade-modal")!
  const _component_banco_modal = _resolveComponent("banco-modal")!
  const _component_ncm_modal = _resolveComponent("ncm-modal")!
  const _component_cfop_modal = _resolveComponent("cfop-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_10, [
                            _createVNode(_component_icone, { nome: "estrela" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 1,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_12, [
                            _createVNode(_component_icone, { nome: "favorito" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas solicitações - Pendentes"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "PENDENTES",
                          cor: "#03a9f4",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusCuradoriaCadastro.Pendente),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarCuradoriasPorStatus(_ctx.EStatusCuradoriaCadastro.Pendente)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas solicitações - Aprovadas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "APROVADOS",
                          cor: "#87e22d",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusCuradoriaCadastro.Aprovado),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarCuradoriasPorStatus(_ctx.EStatusCuradoriaCadastro.Aprovado)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas solicitações - Reprovadas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "REPROVADOS",
                          cor: "#f44336",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusCuradoriaCadastro.Reprovado),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarCuradoriasPorStatus(_ctx.EStatusCuradoriaCadastro.Reprovado)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_card, { titulo: "FILTROS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_a_form_item, {
                          label: "Contratante",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_contratante, {
                              codigoSelecionado: _ctx.state.filtros.codigoContratante,
                              "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.filtros.codigoContratante) = $event)),
                              apresentarCpfCnpj: true
                            }, null, 8, ["codigoSelecionado"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { label: "Data solicitação" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data, {
                              dataSelecionada: _ctx.state.filtros.dataSolicitacao,
                              "onUpdate:dataSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.filtros.dataSolicitacao) = $event))
                            }, null, 8, ["dataSelecionada"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, {
                          label: "Status",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_status_curadoria_cadastro, {
                              valor: _ctx.state.filtros.status,
                              "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.filtros.status) = $event)),
                              limparSelecao: true
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_form_item, {
                          label: " ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "ant-btn ant-btn-primary ss-tamanho-completo",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.buscarCuradorias())),
                              title: "Buscar"
                            }, "Buscar")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                  "data-source": _ctx.state.curadorias,
                  rowKey: "codigo",
                  pagination: false,
                  loading: _ctx.telaBase.carregando,
                  size: "small"
                }, {
                  bodyCell: _withCtx(({ column, record,text }) => [
                    (column.key === 'Codigo')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (record.status === _ctx.EStatusCuradoriaCadastro.Pendente)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.visualizarSolicitacaoCadastro(record))
                              }, "N. " + _toDisplayString(text), 9, _hoisted_26))
                            : (_openBlock(), _createElementBlock("span", _hoisted_27, "N. " + _toDisplayString(text), 1))
                        ], 64))
                      : (column.key === 'Status')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            style: {"vertical-align":"middle","height":"15px","border-radius":"45px"},
                            color: _ctx.obterCorStatus(record.status)
                          }, null, 8, ["color"]))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                          : _createCommentVNode("", true)
                  ]),
                  emptyText: _withCtx(() => [
                    (_ctx.state.curadorias.length <= 0)
                      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                          key: 0,
                          mensagem: "Nenhuma solicitação de cadastro foi encontrada"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_pais_modal, {
            visivel: _ctx.state.apresentarModalPais,
            "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.apresentarModalPais) = $event)),
            operacao: _ctx.state.telaOperacao,
            "onUpdate:operacao": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.telaOperacao) = $event)),
            paisCuradoria: _ctx.state.objetoCadastro,
            onAcaoCuradoria: _ctx.acaoCuradoria
          }, null, 8, ["visivel", "operacao", "paisCuradoria", "onAcaoCuradoria"]),
          _createVNode(_component_estado_modal, {
            visivel: _ctx.state.apresentarModalEstado,
            "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.apresentarModalEstado) = $event)),
            operacao: _ctx.state.telaOperacao,
            "onUpdate:operacao": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.telaOperacao) = $event)),
            estadoCuradoria: _ctx.state.objetoCadastro,
            onAcaoCuradoria: _ctx.acaoCuradoria
          }, null, 8, ["visivel", "operacao", "estadoCuradoria", "onAcaoCuradoria"]),
          _createVNode(_component_cidade_modal, {
            visivel: _ctx.state.apresentarModalCidade,
            "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.apresentarModalCidade) = $event)),
            operacao: _ctx.state.telaOperacao,
            "onUpdate:operacao": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.telaOperacao) = $event)),
            cidadeCuradoria: _ctx.state.objetoCadastro,
            onAcaoCuradoria: _ctx.acaoCuradoria
          }, null, 8, ["visivel", "operacao", "cidadeCuradoria", "onAcaoCuradoria"]),
          _createVNode(_component_banco_modal, {
            visivel: _ctx.state.apresentarModalBanco,
            "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.apresentarModalBanco) = $event)),
            operacao: _ctx.state.telaOperacao,
            "onUpdate:operacao": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.telaOperacao) = $event)),
            bancoCuradoria: _ctx.state.objetoCadastro,
            onAcaoCuradoria: _ctx.acaoCuradoria
          }, null, 8, ["visivel", "operacao", "bancoCuradoria", "onAcaoCuradoria"]),
          _createVNode(_component_ncm_modal, {
            visivel: _ctx.state.apresentarModalNcm,
            "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.apresentarModalNcm) = $event)),
            operacao: _ctx.state.telaOperacao,
            "onUpdate:operacao": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.telaOperacao) = $event)),
            ncmCuradoria: _ctx.state.objetoCadastro,
            onAcaoCuradoria: _ctx.acaoCuradoria
          }, null, 8, ["visivel", "operacao", "ncmCuradoria", "onAcaoCuradoria"]),
          _createVNode(_component_cfop_modal, {
            visivel: _ctx.state.apresentarModalCfop,
            "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.apresentarModalCfop) = $event)),
            operacao: _ctx.state.telaOperacao,
            "onUpdate:operacao": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.telaOperacao) = $event)),
            cfopCuradoria: _ctx.state.objetoCadastro,
            onAcaoCuradoria: _ctx.acaoCuradoria
          }, null, 8, ["visivel", "operacao", "cfopCuradoria", "onAcaoCuradoria"]),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
            retornoRequisicao: _ctx.modalBase.retornoRequisicao
          }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
        ])
      ])
    ])
  ]))
}